import { render, staticRenderFns } from "./banorte-card.vue?vue&type=template&id=30f74121&scoped=true"
import script from "./banorte-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./banorte-card.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f74121",
  null
  
)

export default component.exports